import { KeyboardEvent, useCallback } from 'react';

/**
 * Hook for handling Space/Enter keyboard activation on interactive elements.
 * Used for button-like divs and other custom interactive components.
 *
 * @param onActivate - Callback to execute when Space or Enter is pressed
 * @returns Handler function to attach to onKeyDown
 *
 * @example
 * const handleKeyDown = useKeyboardActivation(() => toggle());
 * <div onClick={toggle} onKeyDown={handleKeyDown} role="button" tabIndex={0} />
 */
export const useKeyboardActivation = (onActivate: (event: KeyboardEvent<HTMLElement>) => void) => {
	return useCallback(
		(event: KeyboardEvent<HTMLElement>) => {
			if (event.key === 'Enter' || event.key === ' ') {
				event.preventDefault();
				onActivate(event);
			}
		},
		[onActivate]
	);
};
